import { Children, useEffect, useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import BusinessIcon from '@mui/icons-material/Business';
import {
  DeleteForeverIcon,
  CheckIcon,
  CloseIcon,
  EditIcon,
  FolderOffIcon,
  FolderCopyIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { useHttpTableAdministradora } from "./Hooks/useHttpTableAdministradora";
import { THeadAdministradora } from "./THead";
import { ModalChangeIsActiveAdministradora } from "../ChangeIsActiveAdministradora/ModalChangeIsActiveAdministradora";
import { ModalAdministradora } from "../Form";

export const TableAdministradora = () => {
  const { listAdministradora, setValuesInputsAdministradora } = useContextComissoes();
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();
  const { handleGet } = useHttpTableAdministradora();
  
  const {
    setActive_incluir,
    setNameSearch,
    itensPerPage,
    currentPage,
    setIdTable,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();

  const [openModalAdministradora, setOpenModalAdministradora] = useState(false);
  const [openModalActiveAdministradora, setOpenModalActiveAdministradora] =
    useState(false);
  const [valueActiveAdministradora, setValueActiveAdministradora] =
    useState<boolean>(true);

  const handleGetIdToEdit = (id: string, administradora: string) => {
    setIdTable(id);
    setId(id);
    setOpenModalAdministradora(true);
    setValuesInputsAdministradora({ name: administradora, is_active: true });
  };

  useEffect(() => {
    handleGet({ itensPerPage, currentPage, nameSearch });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/comissoes/administradoras" });

  return (
    <TableCore
      Modals={
        <>
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
            />
            <ModalChangeIsActiveAdministradora
              isActiveAdministradora={valueActiveAdministradora}
              modalIsActiveAdministradora={openModalActiveAdministradora}
              setModalIsActiveAdministradora={setOpenModalActiveAdministradora}
            />
        </>
      }
      THead={<THeadAdministradora />}
      qtdList={listAdministradora.length}
      setNameSearch={setNameSearch}
      cardAdd={{
              title: "Administradoras",
              icon: <BusinessIcon color="primary" />,
              buttonAdd: [
                <ModalAdministradora
                  key={1}
                  openModal={openModalAdministradora}
                  setOpenModal={setOpenModalAdministradora}
                />,
              ],
            }}
    >
      {Children.toArray(
        listAdministradora.map((item) => {
          return (
            <TableRowCore id={String(item.code)}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.ADMINISTRADORA.EDITAR.id
                        ),
                        onClick: () => {
                          setId(String(item.code));
                          handleGetIdToEdit(String(item.code), item.name);
                          setActive_incluir(true);
                        },
                      },
                      {
                        icon: item.is_active ? (
                          <FolderOffIcon fontSize="small" />
                        ) : (
                          <FolderCopyIcon fontSize="small" />
                        ),
                        background: "warning",
                        title: item.is_active ? "Desativar" : "Ativar",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.ADMINISTRADORA.EDITAR.id
                        ),
                        onClick: () => {
                          setId(String(item.code));
                          setValuesInputsAdministradora({
                            name: item.name,
                            is_active: !item.is_active,
                          });
                          setOpenModalActiveAdministradora(true);
                          setValueActiveAdministradora(!item.is_active);
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.ADMINISTRADORA.DELETAR.id
                        ),
                        onClick: () => {
                          setIdModalDelete(item.code);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore
                values={`${item.code} - ${item.name}`}
              />
              <TdCore
                textAlign="left"
                values={
                  item.is_active ? (
                    <CheckIcon color="success" />
                  ) : (
                    <CloseIcon color="error" />
                  )
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
